/**
 * Vue 3 Composable - 格式化工具函数
 * 在组合式 API 中使用
 */
import * as formats from '@/compositions/filters/format'
import * as dictionaries from '@/compositions/filters/dictionary'

/**
 * 使用格式化函数的组合式函数
 * @returns {Object} 所有格式化函数
 *
 * @example
 * // 在 setup 中使用
 * import { useFilters } from '@/composables/useFilters'
 *
 * const { formatDate, mobile, num } = useFilters()
 * const formatted = formatDate(new Date(), 'yyyy-MM-dd')
 */
export function useFilters() {
  return {
    ...formats,
    ...dictionaries
  }
}

// 也可以单独导出每个函数,便于按需引入
export const {
  date,
  formatDate,
  days,
  num,
  age,
  txt,
  abs,
  mobile,
  idcard
} = formats

export * from '@/compositions/filters/dictionary'
